import { handleException } from 'clients/exception-handling'
import { loadScript } from 'trackers/helper'

export async function initMicrosoftClarity(): Promise<void> {
  const projectId = import.meta.env.VITE_MICROSOFT_CLARITY_PROJECT_ID
  if (!projectId) return

  window.clarity =
    window.clarity ||
    Object.assign(
      (...args: unknown[]) => {
        ;(window.clarity!.q = window.clarity!.q || []).push(args)
      },
      { q: [] as unknown[][] },
    )
  try {
    await loadScript('https://www.clarity.ms/tag/' + projectId)
  } catch (error) {
    handleException(error, {
      operation: 'tracker.microsoft-clarity.initialize',
      disposition: 'recovered',
      reason: 'Application continues without optional analytics.',
    })
  }
}
